
//
import { getFullUrlWithHash, getDigitalCardHostUrl } from "#/utils/common.js"

function digitalCardPay(orderNo, consumeAmount) {
    const successUrl = encodeURIComponent(`${window.location.protocol}//${window.location.host}${window.location.pathname}#/finishOrderDetail?orderType=1&orderState=4&orderNumber=${orderNo}`);

    //
    const failUrl = encodeURIComponent(getFullUrlWithHash());
    
    //
    window.location.href = `${getDigitalCardHostUrl()}pay2Shop?orderId=${orderNo}&consumeAmount=${consumeAmount}&consumeStatus=1&consumeMode=1&redirectSuccess=${successUrl}&redirectFail=${failUrl}`;
}

export {
    digitalCardPay,
}